export const PEEL_KEY = 'qn-sm-peel';

export function peelMean({ cure, plasma, adhesive }) {
  const plasmaOn = plasma === 'yes' ? 1 : 0;
  const b = adhesive === 'B' ? 1 : 0;
  const cureTerm = (Number(cure) - 150) / 30;
  return 0.40 + 0.31 * plasmaOn + 0.055 * cureTerm + 0.025 * b;
}

export function runPeel(factors, seed = Math.random()) {
  const noise = (seed - 0.5) * 0.04;
  const peel = Math.max(0.12, peelMean(factors) + noise);
  return { ...factors, peel: Number(peel.toFixed(3)), id: Date.now() + Math.floor(seed * 1000) };
}

export function mainEffects(rows) {
  if (!rows.length) return { plasma: 0, cure: 0, adhesive: 0 };
  const avg = (pred) => {
    const hit = rows.filter(pred);
    if (!hit.length) return null;
    return hit.reduce((s, r) => s + r.peel, 0) / hit.length;
  };
  const pYes = avg((r) => r.plasma === 'yes');
  const pNo = avg((r) => r.plasma === 'no');
  const cHi = avg((r) => Number(r.cure) >= 175);
  const cLo = avg((r) => Number(r.cure) <= 155);
  const aB = avg((r) => r.adhesive === 'B');
  const aA = avg((r) => r.adhesive === 'A');
  return {
    plasma: pYes != null && pNo != null ? pYes - pNo : 0,
    cure: cHi != null && cLo != null ? cHi - cLo : 0,
    adhesive: aB != null && aA != null ? aB - aA : 0,
  };
}

export function savePeelSnapshot(payload) {
  try { sessionStorage.setItem(PEEL_KEY, JSON.stringify(payload)); } catch { /* ignore */ }
}

export function loadPeelSnapshot() {
  try { return JSON.parse(sessionStorage.getItem(PEEL_KEY) || 'null'); } catch { return null; }
}
